import { useState, useEffect, useCallback } from "react";
import { 
  getExperts, 
  getExpertServices, 
  createExpertService, 
  updateExpertService, 
  addServicePricing,
  getServiceById
} from "../Services/ExpertService";
import { message } from "antd";
import { toast } from "react-toastify";

export const useExpertService = () => {
  const [experts, setExperts] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch experts
  const fetchExperts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getExperts();
      setExperts(data);
    } catch (err) {
      setError(err.message || "Failed to fetch experts");
      console.error("Failed to fetch experts");
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch all services
  const fetchAllServices = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getExpertServices();
      setServices(data.items || []);
    } catch (err) {
      setError(err.message || "Failed to fetch services");
      console.error("Failed to fetch services");
    } finally {
      setLoading(false);
    }
  }, []);

  // Add this function after fetchAllServices
const fetchServiceById = useCallback(async (serviceId) => {
  setLoading(true);
  setError(null);
  try {
    const data = await getServiceById(serviceId);
    return data;
  } catch (err) {
    setError(err.message || "Failed to fetch service details");
    console.error("Failed to fetch service details");
    throw err;
  } finally {
    setLoading(false);
  }
}, []);

  // Create expert service
  const createService = async (serviceData) => {
    try {
      const result = await createExpertService(serviceData);
      toast.success("Expert service created successfully");
      
      // Refresh services
      await fetchAllServices();
      
      return result;
    } catch (err) {
      toast.error(err.message || "Failed to create expert service");
      throw err;
    }
  };


  
// Update  function
const updateService = async (serviceId, serviceData) => {
  try {
     const apiData = {
      title: serviceData.title,
      description: serviceData.description
    };
    
    console.log("Updating service with data:", apiData);
    const result = await updateExpertService(serviceId, apiData);
    toast.success("Expert service updated successfully");
    
    // Refresh services
    await fetchAllServices();
    
    return result;
  } catch (err) {
    toast.error(err.message || "Failed to update expert service");
    throw err;
  }
};

  // Add service pricing
  const addPricing = async (pricingData) => {
    try {
      const result = await addServicePricing(pricingData);
      toast.success("Service pricing added successfully");
      
      // Refresh services to get the updated pricing
      await fetchAllServices();
      
      return result;
    } catch (err) {
      toast.error(err.message || "Failed to add service pricing");
      throw err;
    }
  };

  useEffect(() => {
    fetchExperts();
    fetchAllServices();
  }, [fetchExperts, fetchAllServices]);

  return {
    experts,
    services,
    loading,
    error,
    fetchExperts,
    fetchAllServices,
    fetchServiceById,
    createService,
    updateService,
    addPricing,
  };
};